// extracted by mini-css-extract-plugin
module.exports = {"uploadImage":"oam-institution_uploadImage__3Nt-t","uploadImageText":"oam-institution_uploadImageText__3M26d","editImageText":"oam-institution_editImageText__1j0sU"};